import React, {useEffect, useState} from "react";
import {Box} from "@cjdev-internal/visual-stack";
import {Button} from "@cjdev-internal/visual-stack-x/Button";
import {Select} from "@cjdev-internal/visual-stack-x/Select";
import {
    SlidingPanelDropdown,
    SlidingPanelHeader,
    SlidingPanelSection
} from '@cjdev-internal/visual-stack-redux/lib/components/SlidingPanel';

import {useCampaignsContext} from "../CampaignsContext/useCampaignsContext";
import * as appConstant from "../../constants/appConstant";
import "./Filters.css";

const convertSelectedAdvertiserFilterList = (selectedAdvertiserFilterList) => {
    return selectedAdvertiserFilterList.map((advertiser) => ({
        id: advertiser.value,
        name: advertiser.companyName,
        type: advertiser.type,
    }));
}

export const Filters = ({AccountSelectionDropdown, PublisherSelectionDropdown}) => {
    const [selectedAdvertiserFilterList, setSelectedAdvertiserFilterList] = useState([]);
    const [advertiserOptions, setAdvertiserOptions] = useState([]);
    const [selectedStatusList, setSelectedStatusList] = useState([]);
    const [selectedPublisherFilterList, setSelectedPublisherFilterList] = useState([]);
    const [clearAll, setClearAll] = useState(false);
    const {filterData, setFilterData} = useCampaignsContext();

    useEffect(() => {
        if (selectedAdvertiserFilterList.length === 0) {
            setSelectedPublisherFilterList([]);
            if (clearAll === true) {
                applyFilter();
            }
        }
    }, [selectedAdvertiserFilterList])

    const statusFilterChangeHandler = (value) => {
        setSelectedStatusList(value ? value : []);
    }

    const clearFilter = () => {
        setSelectedAdvertiserFilterList([])
        setSelectedStatusList([])
        setSelectedPublisherFilterList([])
        setClearAll(true); // call this after clearing state variables.
    }

    const applyFilter = () => {
        let convertedAdvertiserList = convertSelectedAdvertiserFilterList(selectedAdvertiserFilterList);
        if (selectedAdvertiserFilterList.length <= 0)
            convertedAdvertiserList = convertSelectedAdvertiserFilterList(advertiserOptions)
        const filters = {
            ...filterData,
            advertisers: convertedAdvertiserList,
            status: selectedStatusList.map(status => status.value),
            publishers: selectedPublisherFilterList.map(publisher => publisher.value)
        }
        setFilterData(filters);
        setClearAll(false);
    }

    return (
        <div className="filter-container">
            <SlidingPanelHeader>{appConstant.Filter_Header}</SlidingPanelHeader>
            <SlidingPanelSection>
                <Box className="filterPanelController" direction="row" gap="medium" padding="medium">
                    <Button type="primary"
                            id="applyFilter"
                            onClick={applyFilter}>{appConstant.APPLY}</Button>
                    <Button type="tertiary"
                            id="clearFilter"
                            onClick={clearFilter}>{appConstant.CLEAR_ALL}</Button>
                </Box>
            </SlidingPanelSection>

            <SlidingPanelSection>
                <SlidingPanelDropdown
                    id="advertiser"
                    label={appConstant.ADVERTISERS}
                    expanded={true}
                >
                    <AccountSelectionDropdown
                        setSelectedAdvertiserFilterList={setSelectedAdvertiserFilterList}
                        optionList={advertiserOptions}
                        setOptionList={setAdvertiserOptions}
                        clearAll={clearAll}/>
                </SlidingPanelDropdown>

                <SlidingPanelDropdown
                    id="publisher"
                    label={appConstant.PUBLISHERS}
                    expanded={true}
                >
                    <PublisherSelectionDropdown
                        selectedAdvertiserFilterList={selectedAdvertiserFilterList}
                        selectedPublisherFilterList={selectedPublisherFilterList}
                        setSelectedPublisherFilterList={setSelectedPublisherFilterList}
                    />
                </SlidingPanelDropdown>

                <SlidingPanelDropdown
                    id="status"
                    label={appConstant.STATUS_LABEL}
                >
                    <Select
                        id="status-select"
                        isMulti
                        options={appConstant.PLACEMENT_STATUS_FIELD}
                        placeholder={appConstant.DROPDOWN_PLACEHOLDER}
                        onChange={statusFilterChangeHandler}
                        value={selectedStatusList}
                    />
                </SlidingPanelDropdown>
            </SlidingPanelSection>
        </div>
    )
}
